import React, { createContext, useContext, useEffect, useState } from "react";
import { apiBaseUrl } from "../config";
import { getDomainInfo } from "../utils/utils";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getUser } from "../reducer/fetchUserSlice";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);
  const { userId } = useParams();


  const { uid } = getDomainInfo(userId);


  const dispatch = useDispatch();
  const fetchUserData = async (userId, uid) => {
    try {
      if (!userId && !uid) {
        console.error("Error: Both userId and uid are undefined or null.");
        return;
      }

      const apiUrl = `${apiBaseUrl}user/get-user-web/${userId ?? uid}`;
      const response = await fetch(apiUrl);
      const data = await response.json();
      dispatch(getUser(data?.User));

      if (data.success && data.User) {
        setUserData(data.User);

        const customTheme = data.User.customBranding?.customTheme;
        if (customTheme && Object.keys(customTheme).length > 0) {
          const { color1, color2, color3, bgcolor } = customTheme;
          document.documentElement.style.setProperty("--primary-color", color1);
          document.documentElement.style.setProperty("--secondary-color", color2);
          document.documentElement.style.setProperty("--tertiary-color", color3);
          document.documentElement.style.setProperty("--body-background", bgcolor);
        }
      } else {
        console.error("Failed to fetch user data:", data.message || "Unknown error");
      }
    } catch (error) {
      console.error("Error in fetchUserData:", error);
    }
  };



  return (
    <UserContext.Provider value={{ userData, fetchUserData }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
